<template>
  <div id="apply-list" class="apply-list ht-scroll-vertical" ref="visitorApplyList">
    <form action="javascript:void(0)" >
      <van-search
          background="#f5f5f5"
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @search="debounceOnSearch"
          :clearable="false"
      />
    </form>

    <van-list
        v-if="!showEmpty"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
    >
      <ApplyItem v-for="(item,index) in list" :key="index" :item="item" />
    </van-list>
    <div class="empty-container" v-else>
      <Error type="empty"/>
    </div>
  </div>
</template>

<script>
import {List, Cell, Search, Toast} from 'vant'
import {debounce} from 'lodash-es'
import {queryVisitorMyApply} from "@/api/visitorApplication"
import ApplyItem from "@/components/VisitorApplication/applyItem"
import App from "@/App";

export default {
  name: 'visitorApplyList',
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Search.name]: Search,
    ApplyItem
  },
  props: ['openId'],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false,
      pageIndex: 0,
      totalPage: 0,
      userId: null,
      userOpenId:null,
      keyword: '',

      flowName:"",
      itemType:"",

      showEmpty:false
    }
  },
  computed: {},
  created() {
    this.userOpenId = this.$route.query.openId
    this.mixinShowLoading()
    this.userOpenId = this.openId
    this.flowName = this.$route.query.flowName,
    this.itemType = this.$route.query.itemType,
    this.debounceOnSearch = debounce(this.onSearch, 100)

  },
  beforeRouteUpdate(to, from, next) {
    this.$refs.visitorApplyList.scrollTop = 0
    this.list = []
    this.pageIndex = 0
    this.loading = true
    this.finished = false
    this.userOpenId = to.params.openId
    this.onLoad()
    this.mixinShowLoading()
    next()
  },
  methods: {
    onLoad() {
      this.error = false
      queryVisitorMyApply(this.pageIndex, this.keyword,this.userOpenId,this.flowName,this.itemType).then(response => {
        console.log("---------------");
        if(response && response.data){
          const respData = response.data;
          if (!respData.total) {
            this.emptyShow = true;
            this.finished = true;
            return;
          }
          this.list = this.list.concat(respData.data)
          if (this.list.length >= respData.total) this.finished = true
          this.totalPage = respData.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          } else {
            this.pageIndex++;
          }
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        Toast.fail('服务器繁忙或网络异常，请稍后重试')
      }).finally(() => {
        this.mixinClearLoading()
      })
    },
    onSearch() {
      this.$refs.visitorApplyList.scrollTop = 0
      this.list = []
      this.pageIndex = 0
      this.loading = true
      this.finished = false
      this.onLoad()
      this.mixinShowLoading()
    },
  }
}
</script>

<style scoped lang="scss">
.apply-list {
  height: 100vh;
}
</style>
